import React from 'react';
import '../../styles/pages/browse-company.css';

function BrowseCompanyPage() {
  return (
    <div className="browse-company-page">
      <div className="browse-company-hero">
        <div className="container">
          <h1 className="page-title">Browse Companies</h1>
          <p className="page-subtitle">Discover top companies and find your perfect match</p>
        </div>
      </div>
      <div className="container">
        <div className="companies-section">
          <p className="coming-soon">Company browsing feature coming soon...</p>
        </div>
      </div>
    </div>
  );
}

export default BrowseCompanyPage;

